import { render, staticRenderFns } from "./ResultServerTable.vue?vue&type=template&id=e624589c"
import script from "./ResultServerTable.vue?vue&type=script&lang=js"
export * from "./ResultServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports